import { forwardRef, type ReactNode } from 'react';

import type { DataTestId } from '../../core/types/data-props.js';
import type { StylingProps } from '../../core/types/styling-props.js';
import { Flex } from '../../layouts/flex/Flex.js';

//#region Typings
/**
 * Accepted properties for the MessageContainer Actions.
 * @public
 */
export interface MessageContainerActionsProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the actions slot. */
  children: ReactNode;
}
//#endregion

/**
 * The MessageContainer Actions component.
 * @public
 */
export const Actions = forwardRef<HTMLDivElement, MessageContainerActionsProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
      ...remainingProps
    }: MessageContainerActionsProps = props;

    return (
      <Flex
        data-testid={dataTestId}
        ref={forwardedRef}
        className={consumerClassName}
        style={consumerStyle}
        alignItems="center"
        flexWrap="wrap"
        flexGrow={1}
        {...remainingProps}
      >
        {children}
      </Flex>
    );
  },
);

(Actions as typeof Actions & { displayName: string }).displayName =
  'MessageContainer.Actions';
